import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OrderSearchTypeConstants } from 'src/app/core/constants/order-search-type-constants';
import { OrderFacade } from 'src/app/store/order/facade';

@Component({
  selector: 'app-order-search',
  templateUrl: './order-search.component.html',
  styleUrls: ['./order-search.component.scss'],
  host: {
    class: 'app-order-search',
  },
  standalone: false,
})
export class OrderSearchComponent implements OnInit {
  router = inject(Router);
  translate = inject(TranslateService);
  orderFacade = inject(OrderFacade);

  selectedFilterType: string;
  filterOrderId: number;
  filterDateFrom: Date;
  filterDateTo: Date;

  async ngOnInit() {
    this.selectedFilterType = OrderSearchTypeConstants.searchByCode;
    this.filterDateFrom = OrderSearchTypeConstants.fromDate;
    this.filterDateTo = OrderSearchTypeConstants.toDate;
  }

  setSearchByDate() {
    this.selectedFilterType = OrderSearchTypeConstants.searchByDate;
    this.orderFacade.setFilterType(this.selectedFilterType);
  }

  setSearchByCode() {
    this.selectedFilterType = OrderSearchTypeConstants.searchByCode;
    this.orderFacade.setFilterType(this.selectedFilterType);
  }

  getIsSearchByDate() {
    return this.selectedFilterType === OrderSearchTypeConstants.searchByDate;
  }

  getIsSearchByCode() {
    return this.selectedFilterType === OrderSearchTypeConstants.searchByCode;
  }

  fromDate = () => {
    this.filterDateFrom.setHours(0, 0, 0);
    this.filterDateTo.setHours(0, 1, 0);
    return this.filterDateFrom;
  };

  toDate = () => {
    this.filterDateFrom.setHours(0, 0, 0);
    this.filterDateTo.setHours(0, 1, 0);
    return this.filterDateTo;
  };

  onFormSubmit = function (e) {
    if (this.getIsSearchByCode()) {
      this.orderFacade.loadById(this.filterOrderId);
    }

    if (this.getIsSearchByDate()) {
      this.orderFacade.loadByDates(this.filterDateFrom, this.filterDateTo);
    }

    e.preventDefault();
  };
}
